import styled from 'styled-components/macro';
import { Button } from '../../button';
import { NumberInput } from '../number-input';

export const StepperInput = styled(NumberInput)`
  input {
    text-align: center;
  }
`;

export const StepButton = styled(Button)`
  &:disabled {
    background-color: transparent;
  }
`;
